import { MediaBreakpointDirection, MediaBreakpoint, getBreakpointWidth } from "Utils/getBreakpointWidth";
import { useEffect, useState } from "react";

export {type MediaBreakpoint} from "Utils/getBreakpointWidth";

function useMediaBreakpoint(direction: MediaBreakpointDirection, breakpoint: MediaBreakpoint): boolean {      
   const breakpointWidth = getBreakpointWidth(direction, breakpoint);
   const [isMatch, setIsMatch] = useState<boolean>(direction == "up" ? window.innerWidth >= breakpointWidth : window.innerWidth <= breakpointWidth);
   const onMediaQueryHandler = (event: MediaQueryListEvent) => {
      setIsMatch(event.matches);
   };   

   
   useEffect(() => {      
      const width = getBreakpointWidth(direction, breakpoint);      
      const mediaQuery = window.matchMedia(direction == "up" 
      ? `(min-width: ${width}px)`
      : `(max-width: ${width}px)`);
      mediaQuery.addEventListener("change", onMediaQueryHandler);

      return function cleanup() {         
         mediaQuery.removeEventListener("change", onMediaQueryHandler);
      }
   }, [direction, breakpoint]);

   return isMatch;
}

export default useMediaBreakpoint;
